import HttpMethodType from 'HttpMethodType';
import SubSystemType from 'SubSystemType';
import BaseServiceRequest from 'BaseServiceRequest';


class GetPdfRequestWebURL extends BaseServiceRequest {
    constructor(pdfResearchPath) {
        super();
        super.addRequestUri("b/download");
        super.addRequestParameter("id", pdfResearchPath);
    }

    getMethod() {
        return HttpMethodType.GET;
    }

    getSubSystem() {
        return SubSystemType.GRAPH;
    }

    getMessageName() {
        return "blob";
    }
}

export default GetPdfRequestWebURL;